module.exports = __webpack_public_path__ + "media/country_flags/ro-e21bab26.png";